export const normalizeFetchComponentsResponse = response =>
    response.map(component => ({
        id: component.layer_id,
        name: component.layer_name,
        weight: component.layer_weight,
        order: component.order,
    }))
